import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { addEventListeners } from '@datadog/browser-core';
import { getNodePrivacyLevel, NodePrivacyLevel } from '@datadog/browser-rum-core';
import { IncrementalSource, MouseInteractionType } from '../../../types';
import { assembleIncrementalSnapshot } from '../assembly';
import { getEventTarget } from '../eventsUtils';
import { getSerializedNodeId, hasSerializedNode } from '../serialization';
import { tryToComputeCoordinates } from './trackMove';
var eventTypeToMouseInteraction = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "pointerup" /* DOM_EVENT.POINTER_UP */, MouseInteractionType.MouseUp), "mousedown" /* DOM_EVENT.MOUSE_DOWN */, MouseInteractionType.MouseDown), "click" /* DOM_EVENT.CLICK */, MouseInteractionType.Click), "contextmenu" /* DOM_EVENT.CONTEXT_MENU */, MouseInteractionType.ContextMenu), "dblclick" /* DOM_EVENT.DBL_CLICK */, MouseInteractionType.DblClick), "focus" /* DOM_EVENT.FOCUS */, MouseInteractionType.Focus), "blur" /* DOM_EVENT.BLUR */, MouseInteractionType.Blur), "touchstart" /* DOM_EVENT.TOUCH_START */, MouseInteractionType.TouchStart), "touchend" /* DOM_EVENT.TOUCH_END */, MouseInteractionType.TouchEnd);
export function trackMouseInteraction(configuration, mouseInteractionCb, recordIds) {
  var handler = function handler(event) {
    var target = getEventTarget(event);
    if (getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN || !hasSerializedNode(target)) {
      return;
    }
    var id = getSerializedNodeId(target);
    var type = eventTypeToMouseInteraction[event.type];
    var interaction;
    if (type !== MouseInteractionType.Blur && type !== MouseInteractionType.Focus) {
      var coordinates = tryToComputeCoordinates(event);
      if (!coordinates) {
        return;
      }
      interaction = {
        id: id,
        type: type,
        x: coordinates.x,
        y: coordinates.y
      };
    } else {
      interaction = {
        id: id,
        type: type
      };
    }
    var record = _objectSpread({
      id: recordIds.getIdForEvent(event)
    }, assembleIncrementalSnapshot(IncrementalSource.MouseInteraction, interaction));
    mouseInteractionCb(record);
  };
  return addEventListeners(configuration, document, Object.keys(eventTypeToMouseInteraction), handler, {
    capture: true,
    passive: true
  });
}